<template>
	<div>
		<h3>Payment options you agree to use</h3>
		<ul>
			<li :class="['bank',{active : bank_transfer}]" @click="bankTransfer">by bank transfer<span class="on_off"><span class="pearl"></span></span></li>
			<li :class="['debit',{active : debit_card}]" @click="debitCard">by debit card<span class="on_off"><span class="pearl"></span></span></li>	
			<li :class="['credit',{active : credit_card}]" @click="creditCard">by credit card<span class="on_off"><span class="pearl"></span></span></li>
			
		</ul>
	</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		props:['credit_card','debit_card','bank_transfer'],

		methods : {
			creditCard(){
				if(this.bank_transfer == false && this.debit_card == false) {
					this.$emit('changeCreditCard',!this.credit_card);
					this.$emit('changeBankTransfer',!this.bank_transfer);
				}
				this.$emit('changeCreditCard',!this.credit_card);
			},
			debitCard(){
				if(this.bank_transfer == false && this.credit_card == false) {
					this.$emit('changeDebitCard',!this.debit_card);
					this.$emit('changeCreditCard',!this.credit_card);
				}
				this.$emit('changeDebitCard',!this.debit_card);
			},
			bankTransfer(){
				if(this.debit_card == false && this.credit_card == false) {
					this.$emit('changeBankTransfer',!this.bank_transfer);
					this.$emit('changeDebitCard',!this.debit_card);	
				}
				this.$emit('changeBankTransfer',!this.bank_transfer);	
			}
		}
	}
</script>

<style lang="scss" scoped>

h3 {
    width: 85%;
    margin-left: auto;
    margin-right: auto;
  }
	ul {
		margin: 0;
		padding: 0;
    	position: relative;

		li {
			position: relative;
			box-sizing: border-box;
			cursor: pointer;
			padding-top: 4px;
			padding-bottom: 16px;
			margin-left: auto;
			margin-right: auto;
			color: #3c424bdb;
			font-family: 'Avenir Next';
    		font-weight: 500;
    		width: 240px;
    		font-size: 16px;
    		letter-spacing: 0.01em;
    		padding-left: 12px;
    		padding-right: 12px;
    		display: inline-block;


    		&:before{
    			position: relative;
    			top: 6px;
    			content: '';
    			width: 23px;
    			height: 23px;
    			display: inline-block;
    			margin-right: 14px;
    			background-image: url('../assets/icon_bank_account.svg');
    			background-size: contain;
    			background-position: center;
    			background-repeat: no-repeat;
    		}

    		&.bank {
    			&:before {
    				top: 5px;
    				background-image: url('../assets/icon_bank_account.svg');
    			}
    		}
    		&.credit {
    			&:before {
    				background-image: url('../assets/icon_credit_card.svg');
    			}
    		}
    		&.debit {
    			&:before {
    				background-image: url('../assets/icon_debit_card.svg');
    			}
    		}
    		

			.on_off {
				right: 0;
				top: 9px;
				display:block;
				width: 42px;
				height: 26px;
				background: #E4E4E4;
				border-radius: 20px;
				position: absolute;

				.pearl {
					transition: all 0.11s;
					display: inline-block;
					width: 20px;
					left: 3px;
					top: 3px;
					position: relative;
					height: 20px;
					border-radius: 20px;
					background: #fff;
					-webkit-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.04);
      				-moz-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.04);
      				box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.04);
				}
			}

			&.active {
				border: none;
				color: #3c424b;

				.on_off {
					background: #0cc3ca;
					.pearl {
						left: 18px;
					}
				}
			}
			border-bottom: 1px solid #cdcdcd80!important;
			&:last-child{
			  border: none!important;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/PickPayin.vue